import React, { useState } from "react";
import PlatinumPlusExclusiveModal from "./PlatinumPlusExclusiveModal";

interface Props {
  isPlusMember: boolean;
  isPlatinumMember: boolean;
}

const PlatinumPlusExclusiveBanner = ({
  isPlatinumMember,
  isPlusMember,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={`member-exclusive__banner member-exclusive__banner--${
          isPlusMember ? "plus" : "platinum"
        }`}
        data-testid="member-exclusive-banner"
      >
        {isPlusMember && <span className="plus-flag">Plus</span>}
        {isPlatinumMember && !isPlusMember && (
          <span className="platinum-flag">Platinum</span>
        )}
        {isPlusMember || isPlatinumMember ? (
          <span className="member-exclusive__content">
            Member Exclusive due to Global Shortage
            <span className="member-exclusive__subtext">
              Available for non-bulk & direct-to-consumer purchases
            </span>
          </span>
        ) : (
          <span className="member-exclusive__content">
            Temporarily Unavailable due to Global Shortage
            <a
              href="##"
              className="member-exclusive__link"
              title="Learn More"
              onClick={(e) => {
                e.preventDefault();
                setIsModalOpen(true);
              }}
            >
              Learn More
            </a>
          </span>
        )}
      </div>
      <PlatinumPlusExclusiveModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default PlatinumPlusExclusiveBanner;
